import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Textarea,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const NoteModal = ({ contractCheck, open, onClose }) => {
    const { auth } = usePage().props;
    const { data, setData, post, processing, errors } = useForm({
        note: contractCheck?.note || '',
    });

    const handleSubmit = () => {
        post(
            `/customers/${auth?.user?.selected_customer_id}/services/ww-check/contract-check/${contractCheck?.id}/notes`,
            {
                preserveScroll: true,
                only: ['employments'],
                onSuccess: onClose,
            }
        );
    };

    return (
        <Modal onClose={onClose} open={open} size='medium'>
            <ModalHeader>Notitie</ModalHeader>
            <ModalContent>
                <Textarea
                    rows={5}
                    value={data.note}
                    error={errors.note}
                    onChange={event => setData('note', event.target.value)}
                />
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose} type='button'>
                    Annuleren
                </Button>
                <Button
                    type='button'
                    variant='primary'
                    loading={processing}
                    onClick={handleSubmit}
                >
                    Opslaan
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default NoteModal;
